const queue: string[] = []

export const audioQueue = {
    add: (audioUrl: string) => {
        queue.push(audioUrl)
    },
    get: () => queue,
}
